module.exports = __webpack_public_path__ + "static/media/FROM_6AM_TO_2PM_AND_7PM_TO_11PM.41fc300a.svg";